export default __webpack_public_path__ + "static/media/ally_background_xl2.2196be94.jpg";